const getGuidedChecklistVariant = ({
    marketingToolsExperimentVariant: { guidedChecklistVariant } = {},
}) => guidedChecklistVariant || null;

export { getGuidedChecklistVariant };
